var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript7279Defd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.845398 0.222656H126.614V125.991H0.845398V0.222656Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9146 105.323L43.5388 99.4983C45.3958 102.79 47.0848 105.576 51.1364 105.576C55.02 105.576 57.4691 104.057 57.4691 98.1478V57.9619H69.2878V98.3148C69.2878 110.556 62.1122 116.128 51.643 116.128C42.1882 116.128 36.7001 111.232 33.9141 105.322",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7075 104.057L85.3307 98.485C87.8642 102.622 91.1568 105.661 96.9814 105.661C101.879 105.661 105.002 103.213 105.002 99.8356C105.002 95.7835 101.794 94.3479 96.3904 91.9849L93.4363 90.7174C84.9092 87.0883 79.253 82.5292 79.253 72.905C79.253 64.0403 86.0067 57.2861 96.5599 57.2861C104.074 57.2861 109.477 59.9037 113.36 66.7418L104.157 72.652C102.131 69.0219 99.9365 67.5868 96.5594 67.5868C93.0979 67.5868 90.9028 69.7819 90.9028 72.652C90.9028 76.1975 93.0979 77.6336 98.163 79.8286L101.118 81.0946C111.164 85.4007 116.82 89.7903 116.82 99.6671C116.82 110.305 108.463 116.13 97.2344 116.13C86.2597 116.13 79.1681 110.896 75.707 104.057",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.768,
    height: 125.768,
    fill: "white",
    transform: "translate(0.845398 0.222656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript7279Defd);
export default __webpack_public_path__ + "static/media/javascript.7279defd.7279defdfa836ba7ddf75a473635dc75.svg";
export { ForwardRef as ReactComponent };